import { createContextLocalStore } from '@/stores/local/createContextLocalStore';

import { SidebarNewsStore } from './SidebarNewsStore';

export * from './SidebarNewsStore';

export const { Provider: SidebarNewsStoreProvider, useStore: useSidebarNewsStore } =
  createContextLocalStore(SidebarNewsStore);
